import { Box } from '@chakra-ui/react';
import * as React from 'react';

const HeroCubeBg = ({ children }: React.PropsWithChildren) => {
  return (
    <Box
      pt={24}
      bgImage={'/images/hero-cube-bg.webp'}
      bgSize={'cover'}
      bgPosition={'center'}
      bgAttachment={'fixed'}
    >
      {children}
    </Box>
  );
};

export default HeroCubeBg;
